<script>
export default {
    props: [
        'accountInfo',
        'method',
        'currency',
        'canxVal'
    ],
    data() {
        return {
            lead: false,
            canxall: false
        };
    },
}
</script>
<template>
    <div>
        <div class="row-fluid">
            <p class="m-auto">{{ accountInfo.accountInfo.cancellationtext }}. Any refund due will be returned to you via
                the original
                method of payment in the next few days. If you wish to go ahead with the cancellation, please confirm by
                clicking the below link. This will also generate a cancellation invoice which can be used for insurance
                claims where required. For verification purposes, we will send an SMS to the mobile number of the lead
                client to confirm the cancellation.</p>

            <h5 class="text-center p-2">{{ accountInfo.accountInfo.cancellationtext }}. At this moment that would equate
                to
                {{ currency.currency }}{{ canxVal.canxVal }}.</h5>
        </div>
        <div class="row-fluid">
            <div class="col-md-12" v-if="canxall === 'No' || lead === 'No'">As you answered no to one or more of the
                above questions, you will need to speak to one of our consultants to further your request.</div>
            <button class="btn btn-info m-auto" @click="$emit('sendSMS')">
                Send SMS code
            </button>
        </div>

    </div>

</template>